import React, { PureComponent } from 'react'
import DesignerBody from '../components/DesignerBody.js'
import CushionDesignerSteps from '../components/CushionDesignerSteps.js'
import { Redirect, Route, Switch } from 'react-router-dom'
import CushionFillingSelector from '../components/CushionFillingSelector.js'
import CushionStyleSelector from '../components/CushionStyleSelector.js'
import CushionFabricSelector from '../components/CushionFabricSelector/CushionFabricSelector.js'
import CushionDimensionsSelector from '../components/CushionDimensionsSelector.js'
import CushionTypeSelector from '../components/CushionTypeSelector.js'
import { DESIGNER_STEPS_PILLOW, DESIGNER_STEPS_URLS_PILLOW } from '../utils/config.js'

class PillowRouter extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <DesignerBody urls={DESIGNER_STEPS_URLS_PILLOW}>
        <CushionDesignerSteps steps={DESIGNER_STEPS_PILLOW} urls={DESIGNER_STEPS_URLS_PILLOW} />
        <Switch>
          <Route path={'/cd/:category/:type/:dimensions/:fabric/:style/:filling'}>
            <CushionFillingSelector />
          </Route>
          <Route path={'/cd/:category/:type/:dimensions/:fabric/:style'}>
            <CushionStyleSelector />
          </Route>
          <Route path={'/cd/:category/:type/:dimensions/:fabric'}>
            <CushionFabricSelector />
          </Route>
          <Route path={'/cd/:category/:type/:dimensions'}>
            <CushionDimensionsSelector />
          </Route>
          <Route path={'/cd/:category/:type'}>
            <div className={'cushion-designer-layout type-selector'}>
              <p className={'cushion-designer-footer-text'}>
                Welcome to the Cushion Designer, a one-of-a-kind custom cushion builder engineered
                to put ease and enjoyment at the forefront of design. Follow the step-by-step
                prompts on screen to create your custom cushion.
              </p>
              <CushionTypeSelector />
            </div>
          </Route>
          <Route path={'/cd/:category'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
          <Route exact path={'/cd'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
          <Route exact path={'/'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
        </Switch>
      </DesignerBody>
    )
  }
}

export default PillowRouter
